module.exports = "/_next/static/images/blue-sticker_ru-d7cab5a447e9d9b09fedbc1bc4846b4c.png";